
import Vue from 'vue';
import gql from 'graphql-tag';
import Multiselect from 'vue-multiselect';

interface IData {
  options: string[];
  query: string;
  initialFetched: boolean;
  skipQuery: boolean;
}

export default Vue.extend({
  components: {
    Multiselect,
  },
  props: {
    campaign: {
      type: Object,
      default: null,
    },
    group: {
      type: Object,
      default: null,
    },
    includeArchivedCampaigns: {
      type: Boolean,
      default: false,
    },
  },
  data(): IData {
    return {
      options: [],
      query: '',
      initialFetched: false,
      skipQuery: true,
    };
  },
  watch: {
    group: {
      handler(newGroup, oldGroup) {
        if (newGroup && oldGroup && newGroup.id !== oldGroup.id) {
          this.initialFetched = false;
        }
      },
      deep: true,
    },
  },
  async mounted(): Promise<void> {
    if (this.$route.query.campaign) {
      // Campaign id present in the query, fetch campaign and set it
      try {
        this.initialFetched = true;
        const result = await this.$apollo.query({
          query: gql`
            query($id: ID!) {
              Campaign(id: $id) {
                id
                name
                currency
                languages
                startDate
                endDate
                createdAt
                provider
              }
            }
          `,
          variables: {
            id: this.$route.query.campaign,
          },
        });
        if (result.data && result.data.Campaign) {
          this.setCampaign(result.data.Campaign);
        }
      } catch (e) {
        if (e.message === 'GraphQL error: Permission denied.') {
          this.$snotify.error('You do not have access to this publisher.');
        } else {
          this.$snotify.error(e.message);
        }
      }
    }
    this.skipQuery = false;
  },
  methods: {
    async setCampaign(v): Promise<void> {
      if (v && v.id != this.$route.query.campaign) {
        await this.$router.push({
          query: Object.assign({}, this.$route.query, {
            campaign: v.id ? v.id : undefined,
          }),
        });
      }
      this.$emit('input', v);
    },
    search(q: string): void {
      this.query = q;
    },
  },
  apollo: {
    options: {
      query: gql`
        query($query: String!, $groupId: ID!, $statuses: [Status!]) {
          Campaigns(
            query: $query
            groupId: $groupId
            statuses: $statuses
            campaignTypes: [ADS, HOUSE_ADS]
          ) {
            campaigns {
              id
              name
              advertiser {
                id
              }
              currency
              languages
              startDate
              endDate
              createdAt
              provider
            }
          }
        }
      `,
      variables(): {
        query: string;
        groupId: string;
        statuses: string[];
      } {
        return {
          query: this.query,
          groupId: this.group.id,
          statuses: ['ACTIVE', 'INACTIVE', 'PENDING'].concat(this.includeArchivedCampaigns ? ['ARCHIVED'] : [])
        };
      },
      update(data): any[] {
        if (data && data.Campaigns && data.Campaigns.campaigns) {
          if (data.Campaigns.campaigns.length === 0) {
            this.$emit('missingCampaigns', true);
          } else {
            this.$emit('missingCampaigns', false);
          }
          const all = { name: 'All campaigns', id: '' };
          if (!this.initialFetched) {
            this.setCampaign(all);
            this.initialFetched = true;
          }
          return [all, ...data.Campaigns.campaigns];
        }
        return [];
      },
      skip(): boolean {
        return this.skipQuery || !this.group || !this.group.id;
      },
      fetchPolicy: 'network-only',
      debounce: 500,
    },
  },
});
